import { DEFAULT_PER_PAGE } from "@/constants";
import type { RedeemedCouponCode, RedeemedCouponsResponse } from "@/types/Coupon";
import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRInfinite from "swr/infinite";

const fetcher = async (url: string) => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<RedeemedCouponsResponse>(url, undefined, { headers }).then((res) => res.couponCodes);
};

const getKey = (pageIndex: number, previousPageData: RedeemedCouponCode[]) => {
  if (previousPageData && !previousPageData.length) {
    return null; // reached the end
  }
  return `/coupons?page=${pageIndex + 1}&per=${DEFAULT_PER_PAGE}`; // SWR key
};

export const useRedeemedCoupons = (handleError: (err: RomanApiError) => void) => {
  const {
    data,
    error,
    isValidating,
    mutate,
    size = 1,
    setSize,
  } = useSWRInfinite(getKey, fetcher, {
    revalidateFirstPage: false,
    onError: (err) => {
      handleError(err);
    },
  });

  return {
    data,
    error,
    isLoading: isValidating,
    refreshCoupons: mutate,
    size,
    setSize,
  };
};
